import React from "react";
import { usePageTitle } from "../hooks/usePageTitle";

const About = () => {
  usePageTitle("About Us");

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-white mb-6">
        About Collect Arena
      </h1>

      <div className="space-y-6 text-gray-300">
        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            What is Collect Arena?
          </h2>
          <p>
            Collect Arena is a knowledge-based quiz platform where users can
            test their knowledge by guessing items from curated lists. Whether
            you're into sports, movies, geography, or any other topic, we have
            lists that challenge and entertain.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            How It Works
          </h2>
          <p>
            Browse through our collection of lists, choose one that interests
            you, and start guessing! Each correct guess reveals an item from the
            list. Track your progress, compete with yourself, and complete lists
            to test your knowledge.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            Our Mission
          </h2>
          <p>
            We believe learning and testing knowledge should be fun and
            engaging. Collect Arena provides a simple, clean platform for users
            to challenge themselves and discover new information across various
            topics.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">Contact</h2>
          <p>
            Have questions or feedback? Reach out to us at{" "}
            <a
              href="mailto:contact@collectarena.com"
              className="text-blue-400 hover:text-blue-300"
            >
              contact@collectarena.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default About;
